export const LOGIN_PENDING="LOGIN_PENDING"
export const LOGIN_SUCCESS="LOGIN_SUCCESS"
export const LOGIN_FAILED="LOGIN_FAILED"
export const SIGNUP_SUCCESS="SIGNUP_SUCCESS"